<template>
  <div>
    <div v-if="aproved">
      <parametros />
      <hr>
      <tabelaOperacoes />
      <hr>
      <totais />
      <hr>
      <actionsFooter
        :update-tabs="updateTabs"
        :toggle-negociar="toggleNegociar"
      />
    </div>

    <b-modal
      ref="selectCredor"
      cancel-variant="secondary"
      ok-only
      ok-title="Selecionar"
      centered
      size="md"
      no-close-on-backdrop
      :title="`cliente com ${credores.length} credores`"
      :ok-disabled="!selectedCredor"
      @ok="setCredor(selectedCredor)"
    >
      <label>Selecione o credor</label>
      <v-select
        label="nome"
        :value="selectedCredor"
        :options="credores"
        :clearable="false"
        @input="getItem"
      />
    </b-modal>
  </div>
</template>

<script>
import {
  BModal,
  VBPopover,
} from 'bootstrap-vue'
import vSelect from 'vue-select'

import dayjs from 'dayjs'
import dayjsBusinessDays from 'dayjs-business-days'
import { mapState } from 'vuex'

// IMportando COmponents
import actionsFooter from './components/actionsFooter.vue'
import Parametros from './components/parametros.vue'
import tabelaOperacoes from './components/tabelaOperacoes.vue'
import totais from './components/totais.vue'
import axios from '../../../../../axios-auth'

dayjs.extend(dayjsBusinessDays)

export default {
  components: {
    vSelect,
    BModal,

    // COmponents
    Parametros,
    tabelaOperacoes,
    totais,
    actionsFooter,
  },
  directives: {
    'b-popover': VBPopover,
  },
  props: {
    toggleNegociar: {
      type: Function,
      required: true,
    },
    updateTabs: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      selectedCredor: null,
    }
  },
  computed: {
    ...mapState({
      credorSelected: state => {
        const { credorSelected } = state.negociar
        return credorSelected
      },
      credores: state => {
        const { credores } = state.negociacao
        return credores
      },
      operacoesCobranca: state => {
        const { operacoesCredor } = state.negociar
        return operacoesCredor
      },
      operacoesSelected: state => state.negociar.operacoesSelected,
      clienteInativo: state => state.negociar.clienteInativo,
    }),
    credores: {
      get() {
        return this.$store.state.negociacao.credores
      },
      set(value) {
        this.$store.commit('negociar/setCredor', value)
      },
    },
    isSituacao() {
      const { id } = this.credorSelected
      if (id) {
        // const { id } = credor
        if (id === parseInt(process.env.VUE_APP_ROOT_FAFIRE) || id === parseInt(process.env.VUE_APP_ROOT_EDUCA_MAIS) || id === parseInt(process.env.VUE_APP_ROOT_i9)) {
          return true
        }
      }
      return false
    },
    aproved() {
      if (this.credorSelected) {
        if (this.operacoesCobranca.length > 0) {
          return true
        }
      }
      return false
    },
  },

  watch: {
    operacoesSelected() {
      this.setParametro()
    },
  },

  mounted() {
    const DOM_BOSCO_LIST = [129, 130, 133]
    if (this.credores.length > 1) {
      const isDomBosco = this.credores.filter(credor => DOM_BOSCO_LIST.includes(credor.id)).length > 0
      if (isDomBosco && isDomBosco.length === this.credores.length) {
        this.setCredor(this.credores[0])
      } else {
        this.$refs.selectCredor.show()
      }
    } else {
      this.setCredor(this.credores[0])
    }

    const now = new Date()
    const dataEntrada = dayjs(now).businessDaysAdd(1).format('YYYY-MM-DD')

    this.$store.commit('negociar/setDataEntrada', dataEntrada)
    // O store dura a sessão inteira: cada negociação começa sem desconto nominal
    this.$store.commit('negociar/setDescontoNominal', false)
  },

  methods: {
    getItem(item) {
      this.selectedCredor = item
    },
    setCredor(item) {
      this.$store.commit('negociar/setCredor', item)
      this.$store.dispatch('negociar/setOperacoesCobranca')
      this.setParametro()
    },

    async setParametro() {
      const DOM_BOSCO_LIST = [129, 130, 133]
      const DOM_DRUMOOD_LIST = [216, 217, 219, 220, 221, 222]

      let { parametros } = this.credorSelected

      const { id } = this.credorSelected

      if (DOM_DRUMOOD_LIST.includes(id)) {
        let dv = null
        try {
          const { data } = await axios.get(`/api/diasvencido/${id}/${this.$route.params.id}`, {
            headers: {
              Authorization: 'Bearer '.concat(localStorage.getItem('token')),
              accept: 'application/json',
            },
          })
          if (!Array.isArray(data?.dados)) {
            throw new Error('Resposta inesperada de diasvencido')
          }
          // Sem operação vencida: mantém os parâmetros sem o ajuste por atraso
          dv = data.dados.length ? Number(data.dados[0].dias_atraso) : null
        } catch (error) {
          // 401 é tratado pelo interceptor (volta ao login). Sem os dias de atraso, não aplica os parâmetros do credor.
          this.$swal({
            title: 'Erro!',
            text: 'Não foi possível calcular os dias de atraso. Recarregue a página ou entre novamente.',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-primary',
            },
            buttonsStyling: false,
          })
          return
        }
        if (dv === null || Number.isNaN(dv)) {
          // sem ajuste por atraso
        } else if (dv < 31) {
          this.credorSelected.parametros['2025.1'].avista.boleto_pix.remuneracao_max = '10'
          this.credorSelected.parametros['2025.1'].avista.cartao_credor.remuneracao_max = '10'
          this.credorSelected.parametros['2025.1'].parcelado.boleto_pix.remuneracao_max = '10'
          this.credorSelected.parametros['2025.1'].parcelado.cartao_credor.remuneracao_max = '10'
        } else if (dv < 91) {
          this.credorSelected.parametros['2025.1'].avista.boleto_pix.remuneracao_max = '10'
          this.credorSelected.parametros['2025.1'].avista.cartao_credor.remuneracao_max = '10'
          this.credorSelected.parametros['2025.1'].parcelado.boleto_pix.remuneracao_max = '10'
          this.credorSelected.parametros['2025.1'].parcelado.cartao_credor.remuneracao_max = '10'
        } else if (dv < 181) {
          this.credorSelected.parametros['2025.1'].avista.boleto_pix.remuneracao_max = '15'
          this.credorSelected.parametros['2025.1'].avista.cartao_credor.remuneracao_max = '15'
          this.credorSelected.parametros['2025.1'].parcelado.boleto_pix.remuneracao_max = '15'
          this.credorSelected.parametros['2025.1'].parcelado.cartao_credor.remuneracao_max = '15'
        } else if (dv < 360) {
          this.credorSelected.parametros['2025.1'].avista.boleto_pix.remuneracao_max = '15'
          this.credorSelected.parametros['2025.1'].avista.cartao_credor.remuneracao_max = '15'
          this.credorSelected.parametros['2025.1'].parcelado.boleto_pix.remuneracao_max = '15'
          this.credorSelected.parametros['2025.1'].parcelado.cartao_credor.remuneracao_max = '15'
        } else if (dv > 361) {
          this.credorSelected.parametros['2025.1'].avista.boleto_pix.remuneracao_max = '20'
          this.credorSelected.parametros['2025.1'].avista.cartao_credor.remuneracao_max = '20'
          this.credorSelected.parametros['2025.1'].parcelado.boleto_pix.remuneracao_max = '20'
          this.credorSelected.parametros['2025.1'].parcelado.cartao_credor.remuneracao_max = '20'
          this.credorSelected.parametros['2025.1'].avista.boleto_pix.juros = '0'
          this.credorSelected.parametros['2025.1'].avista.cartao_credor.juros = '0'
          this.credorSelected.parametros['2025.1'].parcelado.boleto_pix.juros = '0'
          this.credorSelected.parametros['2025.1'].parcelado.cartao_credor.juros = '0'
          this.credorSelected.parametros['2025.1'].avista.boleto_pix.multa = '0'
          this.credorSelected.parametros['2025.1'].avista.cartao_credor.multa = '0'
          this.credorSelected.parametros['2025.1'].parcelado.boleto_pix.multa = '0'
          this.credorSelected.parametros['2025.1'].parcelado.cartao_credor.multa = '0'
        }
      }
      if (DOM_BOSCO_LIST.includes(id)) {
        if (id === 129) {
          const defaultCredorParametro = this.credores.filter(e => e.id === 129)[0]
          parametros = defaultCredorParametro.parametros
        }
      }

      this.$store.commit('negociar/setParametroDefault', parametros.default)
      let key = null
      const setParametro = items => {
        const periodosOperacoes = []
        items.map(item => {
          const dataBr = item.data_vencimento ? item.data_vencimento.split('/') : null
          if (dataBr) {
            const periodo = `${dataBr[2]}.${parseInt(dataBr[1]) <= 6 ? 1 : 2}`
            periodosOperacoes.push(periodo)
          }
        })
        const sorted = periodosOperacoes.sort((a, b) => ((a < b) ? 1 : -1))
        if (!this.isSituacao) {
          sorted.map(item => {
            if (!key) {
              parametros[item] ? key = item : null
            }
          })
        }
        if (!key) {
          const keys = Object.keys(parametros).filter(e => e !== 'default')
          const sortedKeys = keys.sort((a, b) => ((sorted[0] < b) ? 1 : -1))

          if (sortedKeys[0]) {
            if (this.isSituacao) {
              const year = sortedKeys[0].split('.')[0]
              if (!this.clienteInativo) {
                key = `${year}.1`
              } else {
                key = `${year}.2`
              }
            } else {
              // eslint-disable-next-line prefer-destructuring
              key = sortedKeys[0]
            }
          } else if (this.isSituacao) {
            const year = keys[0].split('.')
            if (!this.clienteInativo) {
              key = `${year}.1`
            } else {
              key = `${year}.2`
            }
          } else {
            // eslint-disable-next-line prefer-destructuring
            key = keys[0]
          }
        }
      }

      if (this.operacoesSelected.length > 0) {
        setParametro(this.operacoesSelected)
      } else {
        setParametro(this.operacoesCobranca)
      }

      this.$store.commit('negociar/setParametro', {
        parametroCompleto: parametros[key],
        parametroOptions: Object.keys(parametros),
        parametroKey: key,
      })
    },
  },
  mutations: {
    setDefaultParametros(state, payload) {
      state.defaultParametros = payload
    },
  },
  state: {
    defaultParametros: {},
  },
}
</script>

<style>
  .table-adjust {
    max-width: 600px;
    align-items: center;
    justify-content: center;
  }
</style>
